import { Component, type ReactNode } from 'react'

// Catches render/runtime errors in a subtree (Suspense only catches the loading
// promise, not a throw inside the loaded component) and shows a fallback instead
// of unmounting the whole page — e.g. a WebGL-disabled browser throwing in the 3D
// BadgeViewer must not take the profile down with it.
export class ErrorBoundary extends Component<
  { children: ReactNode; fallback: ReactNode },
  { failed: boolean }
> {
  state = { failed: false }
  static getDerivedStateFromError() {
    return { failed: true }
  }
  render() {
    return this.state.failed ? this.props.fallback : this.props.children
  }
}
